import React from 'react'
import { makeStyles, } from '@material-ui/styles'
import classNames from 'classnames'
import ClassNameType from '@shapr/react-shared/types/ClassName'
import MenuItem from '@material-ui/core/MenuItem'

const SuggestionItem = props => {
  const {
    suggestion,
    index,
    itemProps,
    highlightedIndex,
    selectedItem,
    className,
  } = props
  const classes = useStyles()

  const isHighlighted = highlightedIndex === index
  const isSelected = (selectedItem || '').indexOf(suggestion) > -1

  return (
    <MenuItem
      {...itemProps}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
      className={classNames(classes.root, className)}
    >
      {suggestion}
    </MenuItem>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    flexGrow: 1,
  },
}))

SuggestionItem.propTypes = {
  className: ClassNameType,
}

export default React.memo(SuggestionItem)
